class ElLandingPageStats {
  constructor(section) {
    this.section = section;
    this.numbers = Array.from(section.querySelectorAll('[data-el-stats-count]'));
    this.duration = 1400;
    this.frames = new Map();

    this.init();
  }

  init() {
    if (!this.numbers.length) return;

    this.numbers.forEach((number) => {
      if (!number.dataset.elStatsTarget) {
        number.dataset.elStatsTarget = number.textContent.trim();
      }

      this.setNumber(number, 0);
    });

    this.observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            this.play();
          } else {
            this.reset();
          }
        });
      },
      {
        threshold: 0.35,
      }
    );

    this.observer.observe(this.section);
  }

  play() {
    this.cancelAnimations();
    this.reset(false);

    this.section.classList.remove('is-el-stats-visible');

    requestAnimationFrame(() => {
      this.section.classList.add('is-el-stats-visible');

      this.numbers.forEach((number) => {
        this.animateNumber(number);
      });
    });
  }

  reset(removeVisibleClass = true) {
    this.cancelAnimations();

    if (removeVisibleClass) {
      this.section.classList.remove('is-el-stats-visible');
    }

    this.numbers.forEach((number) => {
      this.setNumber(number, 0);
    });
  }

  cancelAnimations() {
    this.frames.forEach((frame) => {
      cancelAnimationFrame(frame);
    });

    this.frames.clear();
  }

  getNumberParts(value) {
    const match = value.match(/^([^0-9.-]*)(-?\d[\d,]*\.?\d*)(.*)$/);

    if (!match) return null;

    const rawNumber = match[2].replace(/,/g, '');
    const target = Number(rawNumber);

    if (Number.isNaN(target)) return null;

    return {
      prefix: match[1],
      target,
      suffix: match[3],
      decimals: rawNumber.includes('.') ? rawNumber.split('.')[1].length : 0,
      useCommas: match[2].includes(','),
    };
  }

  setNumber(number, value) {
    const targetText = number.dataset.elStatsTarget;
    const parts = this.getNumberParts(targetText);

    if (!parts) {
      number.textContent = targetText;
      return;
    }

    const formattedValue = this.formatNumber(value, parts.decimals, parts.useCommas);

    number.textContent = `${parts.prefix}${formattedValue}${parts.suffix}`;
  }

  animateNumber(number) {
    const targetText = number.dataset.elStatsTarget;
    const parts = this.getNumberParts(targetText);

    if (!parts) return;

    const startTime = performance.now();

    const tick = (currentTime) => {
      const elapsed = currentTime - startTime;
      const progress = Math.min(elapsed / this.duration, 1);
      const easedProgress = 1 - Math.pow(1 - progress, 3);
      const currentValue = parts.target * easedProgress;

      this.setNumber(number, currentValue);

      if (progress < 1) {
        const frame = requestAnimationFrame(tick);
        this.frames.set(number, frame);
      } else {
        number.textContent = targetText;
        this.frames.delete(number);
      }
    };

    const frame = requestAnimationFrame(tick);
    this.frames.set(number, frame);
  }

  formatNumber(value, decimals, useCommas) {
    const fixedValue = value.toFixed(decimals);

    if (!useCommas) return fixedValue;

    const parts = fixedValue.split('.');
    parts[0] = Number(parts[0]).toLocaleString();

    return parts.join('.');
  }
}

document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('.el-landing-page-stats').forEach((section) => {
    if (section.dataset.elStatsInitialized === 'true') return;

    section.dataset.elStatsInitialized = 'true';
    new ElLandingPageStats(section);
  });
});

document.addEventListener('shopify:section:load', (event) => {
  const section = event.target.querySelector('.el-landing-page-stats');

  if (!section || section.dataset.elStatsInitialized === 'true') return;

  section.dataset.elStatsInitialized = 'true';
  new ElLandingPageStats(section);
});